export default "__VITE_ASSET__CVNdECXZ__"